import { Action } from '../../../shared/xs/actions';

export class UpdateOffsettingGoalStorageAction implements Action {
  static readonly type = '[co2Offsetting] Updated offsetting goal to Local storage';
}
